import { DialogController } from "~/components/Base/Dialog/dialog-controller";

export const useNewDialogController = () => {
  return ref(new DialogController());
};
